import React from "react";
import { Mountain, Leaf, Sun, Droplets } from "lucide-react";
import { GEO_META } from "@/lib/api";

// "المصدر الجغرافي" — terrain-based source tag for each product.
// Geography is shown ONLY as a tag/info here — never as a store section.
export default function LandFingerprint({ fingerprint, compact = false }) {
  if (!fingerprint) return null;
  const geoKey = fingerprint.geo_key;
  const meta = GEO_META[geoKey] || {};
  const label = fingerprint.region || meta.name_ar || "";
  const isHill = (fingerprint.terrain || meta.terrain) === "hill";
  const primary = meta.primary;
  if (!label) return null;

  if (compact) {
    return (
      <div
        data-testid="geo-source-badge"
        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold backdrop-blur shadow-sm ${
          primary ? "bg-gold text-olive-deep" : "bg-olive-deep/90 text-ivory"
        }`}
        title={`المصدر الجغرافي: ${label}`}
      >
        <Mountain className={`h-3.5 w-3.5 ${isHill ? "opacity-80" : ""}`} />
        <span>{label}</span>
      </div>
    );
  }

  const chips = [
    { icon: Leaf, val: fingerprint.type, show: !!fingerprint.type },
    { icon: Sun, val: fingerprint.season, show: !!fingerprint.season },
    { icon: Droplets, val: fingerprint.production, show: !!fingerprint.production },
  ].filter((c) => c.show);

  return (
    <div data-testid="geo-source-panel" className="overflow-hidden rounded-2xl border border-olive/15 bg-olive/[0.04]">
      <div className="flex items-center gap-3 border-b border-olive/10 bg-olive/[0.06] px-5 py-4">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-olive text-ivory">
          <Mountain className="h-6 w-6" />
        </span>
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-olive/70">المصدر الجغرافي</div>
          <div className="flex items-center gap-2">
            <span className="font-display text-lg font-bold text-olive-dark">{label}</span>
            {primary && <span className="rounded-full bg-gold/20 px-2 py-0.5 text-[10px] font-bold text-gold">مصدر مميّز</span>}
          </div>
          <div className="text-xs text-ink/50">{isHill ? "تلال فلسطينية أصيلة" : "جبال فلسطينية أصيلة"}</div>
        </div>
      </div>
      {chips.length > 0 && (
        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-3">
          {chips.map((c, idx) => (
            <div key={idx} className="flex items-center gap-2 text-sm text-ink/70">
              <c.icon className="h-4 w-4 shrink-0 text-olive" />
              <span>{c.val}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
